export const VIEWPORT_BREAKPOINTS = {
    DESKTOP: 960,
};
